<template>
  <div class="video-comp" catchtap="stopProgation">
    <template v-if="!showVideo">
      <img class="video-comp-media half-pixel-border" mode="aspectFill" :src="coverSrc" @click.stop="handleClick" />
      <div class="video-comp-duration" catchtap="handleClick">
        <img src="../image/play.png" />
        {{duration ? duration : '播放'}}
      </div>
    </template>
    <video
      v-else
      :id="videoId"
      :autoplay="autoplay"
      class="half-pixel-border video video-comp-media"
      :src="videoSrc"
      controls
      bindfullscreenchange="handleFullScreenChange"
    ></video>
  </div>

</template>

<script>
export default {
  name: 'VideoComp',
  props: {
    videoId: {
      type: String,
      default: ''
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    videoSrc: {
      type: String,
      default: ''
    },
    coverSrc: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: -1
    },
    showVideo: {
      type: Boolean,
      default: false
    },
    duration: {
      type: String,
      default: ''
    }
  },
  methods: {
    async handleClick () {
      // if (!wx.network.isWifi()) {
      //   const res = await wx.pro.showModal({ title: '非wifi环境下播放将耗费手机流量', content: '确定播放？' })
      //   if (!res.confirm) return
      // }
      // this.showVideo = true
      this.$emit('vCompClick')
    },
    handleFullScreenChange (e) {
      this.triggerEvent('vCompFullScreenChange', e.detail)
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

.video-comp{
  position: relative;
  height: 416 / @ratio;
}

.video-comp-media{
  width: 100%;
  height: 100%;
}

img.video-comp-media{
  .webkitCss(object-fit, cover);
  .webkitCss(object-position, center);
}

.video-comp-duration{
  .flex();
  .webkitCss(align-items, center);
  position: absolute;
  right: 32 / @ratio;
  bottom: 32 / @ratio;
  height:44 / @ratio;
  padding: 0 14 / @ratio 0 8 / @ratio;
  font-size:26 / @ratio;
  font-weight: bold;
  color:rgba(255,255,255,1);
  line-height: 44 / @ratio;
  background:rgba(0,0,0,0.75);
  border-radius:22 / @ratio;
  img{
    .square(28 / @ratio);
    margin-right: 16 / @ratio;
  }
}
</style>
